import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { Subject } from 'rxjs';
import { IFormStore } from '../interface';
import { BoardResolutionConfirmModel } from '../model';

type State = { state: 'idle' | 'invalid' } | { state: 'valid'; data: BoardResolutionConfirmModel };

const initialState: State = { state: 'idle' };

@Injectable()
export class BoardResolutionConfirmStore extends ComponentStore<State> implements IFormStore {
  readonly setStateInvalid = this.updater(() => ({ state: 'invalid' }));
  readonly setDataValid = this.updater<BoardResolutionConfirmModel>((_, data) => ({
    state: 'valid',
    data: BoardResolutionConfirmModel.fromJson(data),
  }));
  readonly dataState$ = this.select(s => (s.state === 'valid' ? s : null));
  readonly submit$ = new Subject<void>();

  constructor() {
    super(initialState);
  }
}
